// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2tqok","large":"styles_large__1wdJv"};